import { parseForSchema } from '@/util/jsonHelper'
import { isTest } from '..'
import { SeasonConfig, seasonConfigSchema } from './schema'
import seasons from './season.json'
import { MergedSeason, Season } from '@/features/arcade/types'

export const findSeasonConfigById = (id: number): SeasonConfig => {
  const season = seasons.find(season => season.id === id)

  if (!season) {
    if (!isTest) {
      // eslint-disable-next-line no-console
      console.info(`Config for season ${id} was not found`)
    }
    return null
  }

  return parseForSchema(season, seasonConfigSchema)
}

export const getMergedSeason = (
  season: Season,
  seasonConfig: SeasonConfig
): MergedSeason => {
  return { ...season, ...seasonConfig }
}
